<template>
  <el-dialog
    title="选择地址"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="90%"
    :append-to-body="true"
    class="region-picker-dialog"
    @close="handleClose"
  >
    <div class="region-picker">
      <!-- 返回按钮和层级路径 -->
      <div class="header-bar">
        <div v-if="selectedPath.length > 0" class="back-btn" @click="goBackToPrev">
        
          <span>返回</span>
        </div>
        <div v-else class="placeholder"></div>
        
        <!-- 层级路径 -->
        <div class="path-bar">
          <span
            v-for="(item, index) in selectedPath"
            :key="index"
            class="path-segment"
          >
            <span v-if="index > 0" class="path-separator">/</span>
            <span
              class="path-item"
              :class="{ active: index === selectedPath.length - 1 }"
              @click="goBack(index)"
            >
              {{ item.name }}
            </span>
          </span>
        </div>
      </div>
      
      <!-- 列表 -->
      <div class="region-list">
        <div
          v-for="item in currentList"
          :key="item.id"
          class="list-item"
          @click="selectItem(item)"
        >
          <span class="item-name">{{ item.name }}</span>
          <span class="arrow">›</span>
        </div>
        
        <!-- 空状态 -->
        <div v-if="currentList.length === 0" class="empty-state">
          <span>暂无数据</span>
        </div>
      </div>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button class="cancel-btn" @click="handleClose">取消</el-button>
      <el-button type="primary" class="confirm-btn" @click="confirmSelect">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCascadeRegionQuery } from "@/api/common";
import { getLogionUserInfo } from "@/utils/auth"; // 验权

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: Number,
      default: null
    },
    currentAddress: {
      type: String,
      default: ''
    },
    agentUserId: {
      type:  Number,
      default: 0
    }
  
  },
  watch: {
    show(val) {
      if (val) {
        this.init();
      }
    }
  },
  data() {
    return {
      visible: false,
      currentList: [],
      selectedPath: [],
      selectedValue: [],
      parentAdcode: null,
      regionId: null
    };
  },
  methods: {
    init() {
      this.visible = true;
      this.currentList = [];
      this.selectedPath = [];
      this.selectedValue = [];
      this.loadRegion(this.parentId);
    },
    loadRegion(parentId) {
      console.log('加载区域----', parentId)
      const params = {
        agentUserId: this.agentUserId
      }
      if(parentId && parentId != getLogionUserInfo()?.regionId){
        params.regionId = parentId;
      }
      getCascadeRegionQuery(params).then(res => {
        if (res && res.bizcode === 100) {
          this.currentList = res.data || [];
        }
      });
    },
    selectItem(item) {
      if (this.selectedPath.length === 0) {
        this.selectedValue = [item.id];
      } else {
        if(item.id == this.regionId){
          return;
        }else{
          this.selectedValue = [...this.selectedPath.map(p => p.id), item.id];
        }
      }
      this.selectedPath.push({ 
        id: item.id, 
        name: item.name,
      });
      console.log('选择地址', item)
      
      this.parentAdcode = item.adcode;
      this.regionId = item.id;
      this.loadRegion(item.id);
    },
    goBack(index) {
      this.selectedPath = this.selectedPath.slice(0, index + 1);
      this.selectedValue = this.selectedPath.map(p => p.id);
      const lastItem = this.selectedPath[this.selectedPath.length - 1];
      this.loadRegion(lastItem.id);
    },
    goBackToPrev() {
      if (this.selectedPath.length === 0) return;
      
      if (this.selectedPath.length === 1) {
        this.selectedPath = [];
        this.selectedValue = [];
        this.loadRegion(this.parentId);
      } else {
        this.selectedPath = this.selectedPath.slice(0, -1);
        this.selectedValue = this.selectedPath.map(p => p.id);
        const lastItem = this.selectedPath[this.selectedPath.length - 1];
        this.loadRegion(lastItem.id);
      }
    },
    confirmSelect() {
      if (this.selectedValue.length === 0) {
        this.$message.warning('请选择地址');
        return;
      }
      this.$emit('confirm', {
        value: this.selectedValue,
        parentAdcode: this.parentAdcode,
        regionId: this.regionId,
        path: this.selectedPath.map(p => p.name)
      });
      this.handleClose();
    },
    handleClose() {
      this.visible = false;
      this.$emit('close');
    }
  }
};
</script>

<style scoped lang="scss">
.region-picker-dialog {
  border-radius: 12px;
  overflow: hidden;
  
  ::v-deep .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    
    .el-dialog__title {
      color: #fff;
      font-weight: 600;
      font-size: 16px;
    }
    
    .el-dialog__close {
      color: rgba(255, 255, 255, 0.8);
      
      &:hover {
        color: #fff;
      }
    }
  }
  
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  
  ::v-deep .el-dialog__footer {
    padding: 16px 20px;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
  }
}

.region-picker {
  height: 320px;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.header-bar {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  
  .back-btn {
    display: flex;
    align-items: center;
    padding: 6px 10px;
    color: #409eff;
    font-size: 14px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.25s ease;
    background: #fff;
    margin-right: 12px;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
    
    &:hover {
      background: #ecf5ff;
      transform: translateX(-2px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25);
    }
    
    &:active {
      transform: translateX(0);
    }
    
  }
  
  .placeholder {
    width: 65px;
  }
}

.path-bar {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  
  .path-separator {
    color: #c0c4cc;
    margin: 0 2px;
    font-size: 14px;
  }
  
  .path-item {
    padding: 5px 14px;
    background: #fff;
    border-radius: 20px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.25s ease;
    border: 1px solid #e4e7ed;
    
    &:hover {
      background: #f5f7fa;
      border-color: #dcdfe6;
      transform: translateY(-1px);
    }
    
    &.active {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      border-color: transparent;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.35);
    }
  }
}

.region-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
    
    &:hover {
      background: #c0c4cc;
    }
  }
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  
  &:hover {
    background: linear-gradient(90deg, #f0f5ff 0%, #fff 100%);
    border-left-color: #667eea;
    transform: translateX(4px);
  }
  
  &:active {
    transform: translateX(2px);
  }
  
  .item-name {
    font-size: 14px;
    color: #303133;
    font-weight: 400;
  }
  
  .arrow {
    color: #909399;
    font-size: 18px;
    font-weight: 300;
    transition: all 0.2s ease;
  }
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #c0c4cc;
  font-size: 14px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  .cancel-btn {
    padding: 8px 24px;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.25s ease;
    
    &:hover {
      background: #f5f7fa;
    }
  }
  
  .confirm-btn {
    padding: 8px 28px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.35);
    transition: all 0.25s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.45);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
}
</style>
